var _circle, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgReact = ({
  title,
  titleId,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "-11.5 -10.232 23 20.463",
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  r: 2.05,
  fill: "#61dafb"
})), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  stroke: "#61dafb"
}, /*#__PURE__*/React.createElement("ellipse", {
  rx: 11,
  ry: 4.2
}), /*#__PURE__*/React.createElement("ellipse", {
  rx: 11,
  ry: 4.2,
  transform: "rotate(60)"
}), /*#__PURE__*/React.createElement("ellipse", {
  rx: 11,
  ry: 4.2,
  transform: "rotate(120)"
}))));
export default SvgReact;